import { render, staticRenderFns } from "./RepresentativeReplacements.vue?vue&type=template&id=64719a40&"
import script from "./RepresentativeReplacements.vue?vue&type=script&lang=js&"
export * from "./RepresentativeReplacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports